import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=fe2b7392&"
import script from "./editGroup.vue?vue&type=script&lang=js&"
export * from "./editGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports